/** @file Select options for bone pickers: bones by name, optionally filtered (sockets skip generated bones). */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { BoneDoc, Doc } from '@pose2d/format/types';
import type { SelectOption } from '../../ui-kit/Select';

/** `{ value: id, label: name }` for every bone `keep` accepts (all by default). */
export function boneOptions(doc: Doc, keep: (bone: BoneDoc) => boolean = () => true): SelectOption[] {
  return entriesByName(doc.bones).filter(([, bone]) => keep(bone)).map(([id, bone]) => ({ value: id, label: bone.name }));
}
